import { render, staticRenderFns } from "./SponsorSlider.vue?vue&type=template&id=d9c12562&scoped=true"
import script from "./SponsorSlider.vue?vue&type=script&lang=js"
export * from "./SponsorSlider.vue?vue&type=script&lang=js"
import style0 from "./SponsorSlider.vue?vue&type=style&index=0&id=d9c12562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c12562",
  null
  
)

export default component.exports